<template>
  <div id="app">
    <header class="flex">
      <div class="sign flex">
        <p class="logo"><img src="../public/logo.png" alt="logo"></p>
        <p class="name">Ice <span>Soul</span></p>
      </div>
      <nav>
        <template v-for="link in navLinks">
          <router-link
              v-if="!link.isExternal"
              :key="link.path"
              :to="link.path"
              class="flex"
              exact-active-class="active"
          >
            {{ link.name }}
          </router-link>
          <!-- 外部链接 -->
          <a
              v-else
              :key="link.path"
              :href="link.path"
              target="_blank"
              class="flex"
              rel="noopener noreferrer"
          >
            {{ link.name }}↗
          </a>
        </template>
      </nav>
      <div class="operation"></div>
    </header>

    <!-- 路由出口 -->
    <!-- 添加过渡动画 -->
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath"/>
    </transition>
    <footer id="community">
      <div class="footer-content">
        <h2>BEYOND THE<br><span style="color: var(--accent);">INTERFACE</span></h2>
      </div>

      <!-- 社交媒体链接矩阵 -->
      <div class="footer-socials">
        <div class="social-group">
          <span class="social-label">COMMUNITY / 社区</span>
          <div class="social-links">
            <a :href="item.link" target="_blank" v-for="item in communityLinks" :key="item.name">{{item.name}}</a>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <div class="legal-info">
          <span class="copyright">Copyright © 2024 - 2026 IceSoul. All Rights Reserved.</span>
          <span class="divider">|</span>
          <a :href="filingInfo.link" target="_blank" class="beian-link">{{filingInfo.name}}</a>
        </div>
        <div class="system-status">
          <span class="status-dot"></span> SYSTEM OPERATIONAL
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

import mouseEffectMixin from '@/mixins/mouseEffect'
import {communityLinks, filingInfo} from "@/store/commonData";
export default {
  name: 'App',
  computed: {
    filingInfo() {
      return filingInfo
    },
    communityLinks() {
      return communityLinks
    }
  },
  mixins: [mouseEffectMixin],
  data() {
    return {
      navLinks: [
        { path: '/', name: '首页', isExternal: false },
        { path: '/product', name: '产品', isExternal: false },
        // { path: '/document', name: '文档', isExternal: false },
        { path: 'https://driver.icesoul.io', name: '驱动', isExternal: true },
        { path: '/contact', name: '联系方式', isExternal: false  }
      ],
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  /* 淡入淡出过渡效果 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  background-color: var(--bg);

  header {
    position: fixed;
    top: 0; left: 0;
    width: 100%;
    height: 90px;
    border-bottom: 1px solid var(--border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5%;
    z-index: 1000;
    background: rgba(5, 5, 5, 0.6);
    backdrop-filter: blur(20px);
    .sign {
      width: 400px;
      .logo {
        margin-right: 15px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      .name {
        font-family: var(--font-head);
        font-weight: 700;
        font-size: 1.8rem;
        letter-spacing: 1px;
        color: var(--main-text);
        text-transform: uppercase;
        span {
          color: var(--accent);
        }
      }

    }
    nav {
      display: flex;
      gap: 50px;
      list-style: none;
      height: 100%;
      a {
        height: 100%;
        text-decoration: none;
        color: var(--main-text);
        font-size:  1.3rem;
        min-width: 60px;
        text-transform: uppercase;
        letter-spacing: 2px;
        transition: 0.3s;
        opacity: 0.6;
      }
      a.active {
        color: var(--accent);
        opacity: 1;
      }
      a:not(.active):hover {
        color: var(--main-text);
        opacity: 1;
      }
    }
    .operation {
      width: 400px;
    }
  }
  /* --- 优化后的页脚样式 --- */
  footer {
    padding: 100px 8% 50px;
    border-top: 1px solid var(--border);
    background: #020202;
  }

  .footer-content h2 {
    font-size: 4vw;
    letter-spacing: -3px;
    margin-bottom: 60px;
    line-height: 1;
    color: var(--main-text);
  }

  .footer-socials {
    margin-bottom: 80px;
  }

  .social-label {
    display: block;
    font-size: 0.65rem;
    color: var(--dim-text);
    letter-spacing: 3px;
    margin-bottom: 25px;
  }

  .social-links {
    display: flex;
    flex-wrap: wrap;
    gap: 40px;
  }

  .social-links a {
    color: var(--main-text);
    text-decoration: none;
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 1px;
    transition: 0.3s;
    position: relative;
    padding-bottom: 5px;
  }

  .social-links a::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0;
    width: 0; height: 1px;
    background: var(--accent);
    transition: 0.3s;
  }

  .social-links a:hover {
    color: var(--accent);
  }

  .social-links a:hover::after {
    width: 100%;
  }

  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
    border-top: 1px solid rgba(255,255,255,0.05);
  }

  .legal-info {
    font-size: 0.9rem;
    color: #444;
    letter-spacing: 1px;
  }

  .beian-link {
    color: #444;
    text-decoration: none;
    transition: 0.3s;
  }

  .beian-link:hover {
    color: var(--dim-text);
  }

  .divider {
    margin: 0 15px;
    color: #222;
  }

  .system-status {
    font-size: 0.6rem;
    color: var(--dim-text);
    display: flex;
    align-items: center;
    gap: 8px;
    letter-spacing: 2px;
  }

  .status-dot {
    width: 6px;
    height: 6px;
    background: #00ff66;
    border-radius: 50%;
    box-shadow: 0 0 10px #00ff66;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.3; }
    100% { opacity: 1; }
  }

  @media (max-width: 768px) {
    .footer-bottom {
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
    }
    .social-links {
      gap: 20px;
    }
    .divider { display: none; }
    .legal-info span, .legal-info a { display: block; margin-bottom: 5px; }
  }
}
</style>
